import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'

export const Footer = styled(Flex)(
  ({ show }) => css`
    pointer-events: ${!show && 'none'};
  `,
)
